import Loader from "./loader";
import clsx from "clsx";

const FullScreenLoader = ({ className }: { className?: string }) => {
    return (
        <div
            className={clsx(
                "fixed top-0 left-0 right-0 z-50 mx-auto flex h-screen w-full max-w-[420px] items-center justify-center bg-primary bg-opacity-10 backdrop-blur-lg md:border-l md:border-r",
                className
            )}
        >
            <Loader />
        </div>
    );
};

export default FullScreenLoader;
